
import orderUtil from "../Utils/orderUtil.js";

const Css = {
  getPatternSty(width){
    return {
      width: width + "px",
      height: orderUtil.controlBoxHeight + "px",
      backgroundColor: "#1A1A1A",
      float: "left",
      marginLeft: "2px",
      overflow: "hidden"
    }
  }
}

export default Css;